import React, { Component } from 'react';
import i18n from '../../../../i18n';
import { connect } from 'react-redux';
import './InputArea.scss'

class InputArea extends Component {
    handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.props.onClick()
        }
    }
    render() {
        const { onChange, textValue, onClick, setInputRef, id, setFocus, handleBlurInputField } = this.props
        return (
            <div className='input-area-wrapper'>
                <div className='comment-input'>
                    <textarea className='input-comment' onFocus={() => setFocus(id)} onBlur={handleBlurInputField} ref={ref => setInputRef(id, ref)} onKeyPress={this.handleKeyPress} value={textValue} onChange={onChange} placeholder={i18n.t("mobile.gallery.comment.placeholder")} />
                    <div className='input-registration' onClick={onClick}>{i18n.t("mobile.gallery.comment.btn")}</div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    lang: state.langStore.lang,

})

export default connect(
    mapStateToProps,
    null
)(InputArea)
